exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Rb2poKXFoONAJYhKKA0-a{font-size:16px;background:none;margin:0 0 20px 0;padding:10px 15px;border:1px solid #c8c8c8;border-radius:5px;-webkit-border-radius:5px;box-sizing:border-box;width:100%;height:100%;min-height:42px}._2H1XA2463n0r0JnWNOlm0W{height:44px}\n", ""]);

// Exports
exports.locals = {
	"SearchableMultiSelect": "Rb2poKXFoONAJYhKKA0-a",
	"expandedInput": "_2H1XA2463n0r0JnWNOlm0W"
};